import type { Blueprint } from "@/features/blueprints/blueprintTypes";

type DeleteBlueprintDialogProps = {
  blueprint: Blueprint | null;
  isDeleting: boolean;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
};

export function DeleteBlueprintDialog({
  blueprint,
  isDeleting,
  onCancel,
  onConfirm,
}: DeleteBlueprintDialogProps) {
  if (!blueprint) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/40 px-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-blueprint-title"
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl"
      >
        <h2
          id="delete-blueprint-title"
          className="text-lg font-semibold text-slate-950"
        >
          Delete blueprint draft?
        </h2>
        <p className="mt-3 text-sm leading-6 text-slate-600">
          This will permanently delete{" "}
          <span className="font-semibold text-slate-900">
            {blueprint.title}
          </span>
          .
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isDeleting}
            className="rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => void onConfirm()}
            disabled={isDeleting}
            className="rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:bg-red-300"
          >
            {isDeleting ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
